import React from 'react';

import NavigationItems from "../NavigationItems/NavigationItems";
import "./Toolbar.css"

const Toolbar = (props) => {


    return (
        <header className="Toolbar">
            <NavigationItems />
        </header>
    );
}

export default Toolbar;